'use strict';


import './timer.css'

// 核心
import React from 'react';
import {EventEmitter} from 'events';

//
import Component from '../core/component';
import Enhance from '../core/enhance';


/**
 *
 */
class Switch extends Component {
    state = {
        timer: 0,
        show: false,
    }

    constructor(props, context) {
        super(props, context);
    }

    /**
     * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
     */
    componentDidMount() {
        this.state.timer = setTimeout(this.handlerTimeout, this.props.time);
    }

    /**
     * 在组件从 DOM 中移除的时候立刻被调用。
     */
    componentWillUnmount() {
        clearTimeout(this.state.timer);
    }


    render() {
        return <div className="c-timer">{this.state.show ? this.props.children : null}</div>
    }

    handlerTimeout = () => {
        this.setState({show: true})
    }

}

export default Enhance(Switch, {}, 'Switch');